import React, { useContext, useState } from 'react'

import { Box, Typography, useTheme } from '@mui/material'
import Image from 'next/image'
import Button from '@/components/Common/Button'
import OfferSubscription from '@/components/Subscription/OfferSubscription'
import ProfileContext from '@/components/Context/ProfileContext'
import SectionTitle from '@/components/Common/SectionTitle'

const boxStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  // Make items fluid on mobile and fixed on desktop
  height: { xs: 'auto', md: '160px' },
  width: { xs: '100%', sm: '50%', md: '200px' },
  textAlign: 'center',
  paddingTop: { xs: 1, md: 0 },
  paddingBottom: { xs: 1, md: 0 },
}

const HomeAdvantage: React.FC = () => {
  const [openDialog, setOpenDialog] = useState<boolean>(false)
  const { profile } = useContext(ProfileContext)
  const theme = useTheme()

  const textStyle = {
    fontWeight: 'bold',
    color: theme.palette.primary.main,
    marginBottom: 2,
    marginTop: 2,
    fontSize: { xs: '12px', md: '14px' },
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    textAlign: 'center',
  }

  if (profile?.groupAeliaStore) {
    return null
  }

  return (
    <div>
      <OfferSubscription
        dialogVersion={true}
        openDialog={openDialog}
        setOpenDialog={setOpenDialog}
      />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          width: '100%',
        }}
      >
        <SectionTitle>{t({ id: 'web_home_pms_advantage' })}</SectionTitle>

        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            alignItems: 'center',
            borderRadius: '0px',
            width: '100%',
            flexWrap: { xs: 'nowrap', md: 'wrap' },
            gap: { xs: 2, md: 0 },
            justifyContent: {
              xs: 'center',
              md: 'space-around',
            },
          }}
        >
          <Box sx={{ ...boxStyle }}>
            <Image
              src={'/images/icons/home/advantages/abonnement.svg'}
              alt={'next'}
              width={100}
              height={100}
              style={{ marginBottom: 2 }}
            />
            <Typography variant="body2" sx={textStyle}>
              Abonnement premium pour <br />
              bénéficier d'avantages <br />
              supplémentaires
            </Typography>
          </Box>

          {profile?.globalFrancoMagic > 0 && (
            <Box
              sx={{
                ...boxStyle,
              }}
            >
              <Image
                src={'/images/icons/home/shipping_yellow.svg'}
                alt={'next'}
                width={72}
                height={76}
                style={{ marginBottom: 2 }}
              />

              <Typography variant="body2" sx={textStyle}>
                Frais de port offerts <br /> dès{' '}
                {profile?.globalFrancoMagic}€ de commande
              </Typography>
            </Box>
          )}
          <Box
            sx={{
              ...boxStyle,
            }}
          >
            <Image
              src={'/images/icons/home/pcb_yellow.svg'}
              alt={'next'}
              width={72}
              height={76}
              style={{ marginBottom: 2 }}
            />

            <Typography variant="body2" sx={textStyle}>
              Achat au PCB
            </Typography>
          </Box>

          <Box
            sx={{
              ...boxStyle,
            }}
          >
            <Image
              src={'/images/icons/home/notes.svg'}
              alt={'next'}
              width={72}
              height={76}
              style={{ marginBottom: 2 }}
            />

            <Typography variant="body2" sx={textStyle}>
              Aucune conditions croisées
            </Typography>
          </Box>
        </Box>
        <Box>
          <Button
            sx={{
              marginTop: { xs: 1, md: 4 },
              height: 40,
              width: { xs: '100%', md: 430 },
            }}
            onClick={() => setOpenDialog(true)}
          >
            Découvrir l'abonnement Premium
          </Button>
        </Box>
      </Box>
    </div>
  )
}

export default HomeAdvantage
